import http from './http.mjs'
import {setUser, useUser} from './user.mjs'

export default () => {
    const user = useUser()

    if (! user) {
        return [
            null,

            () => {
                throw new Error('No current user.')
            }
        ]
    }

    const {
        currPrjId,
        currPrjName,
        currPrjNo,
        currPrjSver,
        currPrjTeamId,
        prjTypeCode,
        subTypeCode,
        pkid,
    } = user

    const currentProject = {
        pkid: currPrjId,
        prjName: currPrjName,
        prjNo: currPrjNo,
        prjTypeCode,
        subTypeCode,
        sVer: currPrjSver,
        teamId: currPrjTeamId,
    }

    const setCurrentProject = async (currPrjId, currPrjSver) => {
        const {
            currPrjName,
            currPrjNo,
            currPrjTeamId,
            prjTypeCode,
            subTypeCode,
        } = await http.put(
            '/tmusers/modifyPrj',
            {currPrjId, currPrjSver, pkid}
        )

        setUser({
            ...user,
            currPrjId,
            currPrjName,
            currPrjNo,
            currPrjSver,
            currPrjTeamId,
            prjTypeCode,
            subTypeCode,
        })
    }

    return [currentProject, setCurrentProject]
}
